import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AtomCheckBoxComponent } from './atom-check-box.component';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [AtomCheckBoxComponent],
    exports: [AtomCheckBoxComponent],
})
export class AtomCheckBoxModule {}
